/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClassificationType } from '../../models/classification-type';
import { DemoAccountDataExportCto } from '../../models/demo-account-data-export-cto';

export interface ExportDemoAccountDataAsync$Json$Params {
  demoDataType: ClassificationType;
  documentId?: string;
}

export function exportDemoAccountDataAsync$Json(http: HttpClient, rootUrl: string, params: ExportDemoAccountDataAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoAccountDataExportCto>> {
  const rb = new RequestBuilder(rootUrl, exportDemoAccountDataAsync$Json.PATH, 'get');
  if (params) {
    rb.path('demoDataType', params.demoDataType, {});
    rb.query('documentId', params.documentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DemoAccountDataExportCto>;
    })
  );
}

exportDemoAccountDataAsync$Json.PATH = '/demo-account-data/{demoDataType}/export';
